module.exports = __webpack_public_path__ + "media/images/iconSocialMail__okGreen-a50acd3f00d251b4a2a4cd929ac417db.png";